import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import { delayDagMockMutation } from '@/entities/dag/api/_internal/dagMockDelay';
import { createAirflowDagInMockStore } from '@/entities/dag/api/_internal/dagMockStore';
import { shouldUseDagMockApi } from '@/entities/dag/api/_internal/shouldUseDagMockApi';
import type { CreateDagRequest } from '@/entities/dag/domain/types';

export const createDagApi = async (request: CreateDagRequest): Promise<void> => {
  if (shouldUseDagMockApi()) {
    await delayDagMockMutation('standard');
    createAirflowDagInMockStore({
      name: request.name,
      maturity: request.maturity,
      datasourceId: request.dataSourceId ?? '',
      description: request.description ?? '',
      entityType: request.entityType ?? undefined,
      tags: request.tags,
    });
    return;
  }

  await cycloneApiClient.post('/dags/', request);
};
